import HeroSection from '@/sections/HeroSection';
import TrustStrip from '@/sections/TrustStrip';
import CategoriesSection from '@/sections/CategoriesSection';
import MostOrderedSection from '@/sections/MostOrderedSection';
import ProtocolsSection from '@/sections/ProtocolsSection';
import QuizCTASection from '@/sections/QuizCTASection';
import OnboardingSection from '@/sections/OnboardingSection';
import WhyWeTestSection from '@/sections/WhyWeTestSection';
import DistributorSection from '@/sections/DistributorSection';
import FAQSection from '@/sections/FAQSection';

export default function HomePage() {
  return (
    <>
      <HeroSection />
      <TrustStrip />
      <CategoriesSection />
      <MostOrderedSection />
      <ProtocolsSection />
      <QuizCTASection />
      <OnboardingSection />
      <WhyWeTestSection />
      <DistributorSection />
      <FAQSection />
    </>
  );
}
